import { Button } from '@material-ui/core';
import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import UpdatePopup from '../UserDetails/UpdatePopup';
import UserPassword from '../UserPassword/UserPassword';
import './UpdateUserPassword.scss'

const UpdateUserPassword: React.FC = () => {
  const history = useHistory();
  const [success, setSuccess] = React.useState(false);
  const [user] = React.useState({});
  const userPasswordRef = useRef(null);
  const [nextButtonDisabledState, setNextButtonDisabledState] = React.useState(false);

  const changePassword = async () => {
    if (userPasswordRef && userPasswordRef.current) {
      const current = userPasswordRef?.current as any;
      const res = await current.next();
      setSuccess(true);
    }
  }

  return (
    <div className="UpdateUserPassword">
      <UserPassword
        user={user}
        setNextButtonDisabledState={setNextButtonDisabledState}
        ref={userPasswordRef}
        updatePassword={true} 
      />

      <div className='buttons-row'>
        <Button 
          className="back-button"
          variant="contained"
          color="primary"
          onClick={() => history.push('/userAccount')}
        >
          Back
        </Button>
        <Button 
          className="green-button"
          variant="contained"
          color="primary"
          onClick={changePassword}
          disabled={nextButtonDisabledState}
        >
          Save
        </Button>
      </div>
      <UpdatePopup open={success} close={() => {
        setSuccess(false);
        history.push('/userAccount');
      }} />
    </div>
  )
}

export default UpdateUserPassword;
